import { render, staticRenderFns } from "./elevator-maintenance.vue?vue&type=template&id=4cb04e54&scoped=true"
import script from "./elevator-maintenance.vue?vue&type=script&lang=js"
export * from "./elevator-maintenance.vue?vue&type=script&lang=js"
import style0 from "./elevator-maintenance.vue?vue&type=style&index=0&id=4cb04e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb04e54",
  null
  
)

export default component.exports